<template>
	<div class="group-heading display-flex flex-row flex-align-center flex-justify-space-between">
		<GroupName :group="group" ref="name" class="group-name" :hasEditPermissions="hasEditPermissions">
			<div class="details">
				{{ groupDetails }}
			</div>
		</GroupName>
		<div class="display-flex flex-row flex-align-center width-100 flex-justify-end" v-if="hasEditPermissions">
			<div v-if="isSyncedGroup" class="display-flex flex-row flex-align-center">
				<Row class="display-flex flex-row flex-align-center">
					<GroupHeadingSyncStatus :isSyncActive="isSyncActive" :lastSyncedText="lastSyncedText" />
					<AnemicButton :loading="isSyncing" :disabled="isSyncing" @click="syncGroup" tile class="sync-button mx-1">
						<AppIcon width="16" height="16" name="refresh" />
					</AnemicButton>
				</Row>
			</div>
			<div v-else class="display-flex flex-row flex-align-center">
				<v-btn color="#FFFFFF" class="pr-4" @click="addSubGroup"> Add sub group</v-btn>
				<SecondaryButton class="mx-2" smallBtn @click="isShowDialog = true"> Edit users</SecondaryButton>
			</div>
			<GroupOptionsDropdown
				@rename="renameGroup"
				@delete="deleteGroupDialog"
				:isSyncedGroup="isSyncedGroup"
				@make-group-manual="makeGroupManual"
			/>
		</div>
		<AddUserDialog :isShowDialog.sync="isShowDialog" :group="group" />
		<DeleteGroupDialog
			:groupName="groupName"
			@ok="deleteGroup"
			@cancel="deleteGroupDialogShow = false"
			:showDialog.sync="deleteGroupDialogShow"
		/>
	</div>
</template>

<script>
import moment from 'moment';
import { mapActions, mapGetters } from 'vuex';

import GroupHeadingSyncStatus from './GroupHeadingSyncStatus.vue';
import GroupName from './GroupName';
import AppDialogManagerService from '../../dialogs/AppDialogManager/app-dialog-manager-service';
import AddUserDialog from '../../dialogs/settings/groups/AddUserDialog';
import DeleteGroupDialog from '../../dialogs/settings/groups/DeleteGroupDialog';
import GroupOptionsDropdown from '@/components/Settings/groups/GroupOptionsDropdown.vue';
import { updateGroup, deleteGroup, createGroup, syncGroup, makeSyncedGroupManual } from '@/store/modules/accountGroups/actions';
import { defaultGroupName } from '@/store/modules/accountGroups/getters';
import { getService } from '@/store/modules/apps/getters';
export default {
	name: 'GroupHeading',
	components: {
		GroupName,
		AddUserDialog,
		DeleteGroupDialog,
		GroupOptionsDropdown,
		GroupHeadingSyncStatus,
	},
	props: {
		group: { type: Object },
		hasEditPermissions: { type: Boolean },
	},
	computed: {
		...mapGetters([defaultGroupName.fullPath, getService.fullPath]),
		groupDetails() {
			return `${this.group?.sub_groups?.length || 0} sub groups, ${this.group?.users?.length || 0} users`;
		},
		groupName() {
			return this.group?.name || '';
		},
		menuItems() {
			return [
				{ id: 0, title: 'Rename', onClick: this.renameGroup },
				{ id: 1, title: 'Delete', onClick: this.deleteGroupDialog },
			];
		},
		goBackPayload() {
			if (this.group?.parent) {
				return {
					name: 'ManageSingleGroup',
					params: { groupId: this.group.parent },
				};
			}
			return {
				name: 'ManageGroups',
			};
		},
		isSyncedGroup() {
			return !!this.group?.synced;
		},
		isSyncActive() {
			return this.group?.synced?.is_active;
		},
		lastSyncedDate() {
			return moment(String(this.group.synced.last_synced)).format('MM.DD.YYYY');
		},
		lastSyncedTime() {
			return moment(String(this.group.synced.last_synced)).format('HH:mm');
		},
		lastSyncedText() {
			return this.group?.synced.last_synced ? `Last synced ${this.lastSyncedDate} | ${this.lastSyncedTime}` : 'Not synced yet';
		},
	},
	watch: {},
	methods: {
		...mapActions([updateGroup.fullPath, deleteGroup.fullPath, createGroup.fullPath, syncGroup.fullPath, makeSyncedGroupManual.fullPath]),
		makeGroupManual() {
			this[makeSyncedGroupManual.fullPath]({ id: this.group.id });
		},
		async addSubGroup() {
			await AppDialogManagerService.openManualGroupDialog({ parent: this.group.id });
		},
		renameGroup() {
			this.$nextTick(() => {
				this.$refs.name.renameGroup();
			});
		},
		deleteGroupDialog() {
			this.deleteGroupDialogShow = true;
		},
		deleteGroup() {
			this.deleteGroupDialogShow = false;
			this[deleteGroup.fullPath]({ id: this.group.id });
			this.$router.push(this.goBackPayload);
		},
		async editConnection() {
			await AppDialogManagerService.openSyncedGroupDialog({
				defaultProfileId: this.group.synced?.credentials,
				defaultServiceId: this[getService.fullPath](this.group.synced?.service)?.id,
				isUpdate: true,
				group: this.group,
			});
		},
		async syncGroup() {
			this.isSyncing = true;
			try {
				await this[syncGroup.fullPath]({ id: this.group.id });
				this.$toast.success('Group successfully synced');
			} catch (err) {
				this.$toast.error('Failed syncing groups');
			} finally {
				this.isSyncing = false;
			}
		},
	},
	data: () => ({
		isSyncing: false,
		isShowDialog: false,
		deleteGroupDialogShow: false,
	}),
};
</script>

<style scoped lang="scss">
.group-heading {
	height: 115px;
	width: 100%;
	background: #f5f5f5;
	border-radius: 10px;
	padding: 0px 20px;
	.group-name {
		width: 600px;
		::v-deep {
			.name {
				padding-left: 14px;
			}
		}
		.details {
			font-size: 12px;
		}
	}
	.button-container {
		width: 390px;
	}
}
.sync-time {
	color: var(--secondary-font-color);
}
.sync-button {
	width: 36px !important;
	height: 36px !important;
	padding: 0px !important;
	border-radius: 8px !important;
	background: var(--white) !important;
	border: 1px solid var(--border-color) !important;
}
</style>
